export { QRPdf } from "./qr-pdf";
